import { css } from 'styled-components'

export const Colors = css`
  :root {
    --black: #000000;
    --black-3: #606060;
    --white: #ffffff;
    --white-2: #f1f5f3;

    --green: #55bc7e;
    --green-2: #ecfff3;

    --blue: #3850ec;
    --blue-2: #18344a;
    --blue-3: #1251df;

    --red: #ff0000;
    --red-2: #ef3535;
    --red-3: #e94949;
    --yellow: #feb830;
    --orange: #ff8b0e;

    --gray-28: #282828;
    --gray-34: #343434;
    --gray-4f: #4f4f4f;
    --gray-51: #515151;
    --gray-64: #646464;
    --gray-78: #787878;
    --gray-7a: #7a828f;
    --gray-7f: #7f7f7f;
    --gray-a7: #a7a7a7;
    --gray-bb: #bbbbbb;
    --gray-be: #bebebe;
    --gray-dd: #dddddd;
    --gray-df: #dfdfdf;
    --gray-d5: #d5e2e8;
    --gray-e8: #e8e8e8;
    --gray-ef: #efefef;
    --gray-f4: #f4f4f4;
    --gray-f5: #f5f5f5;
    --gray-f8: #f8f8f8;
    --gray-f9: #f9f9f9;
    --gray-fb: #fbfbfb;

    --sub-8: #cfd2d5;
  }
`
